import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Faq } from 'ui/atoms/Faq/Faq';
import { AccessRoutes } from 'ui/organisms/AccessRoutes/AccessRoutes';
import { NumberedRowsSection } from 'ui/organisms/NumberedRowsSection/NumberedRowsSection';

import { LegalEvaluation } from 'landing-pages/legal/sections/LegalEvaluation/LegalEvaluation';
import { LegalFounderStatement } from 'landing-pages/legal/sections/LegalFounderStatement/LegalFounderStatement';
import { LegalHero } from 'landing-pages/legal/sections/LegalHero/LegalHero';
import { LegalLifeOfMatter } from 'landing-pages/legal/sections/LegalLifeOfMatter/LegalLifeOfMatter';
import { LegalMonitoring } from 'landing-pages/legal/sections/LegalMonitoring/LegalMonitoring';
import { LegalRegistryMarquee } from 'landing-pages/legal/sections/LegalRegistryMarquee/LegalRegistryMarquee';
import { LegalSanctions } from 'landing-pages/legal/sections/LegalSanctions/LegalSanctions';
import { LegalUboDiscovery } from 'landing-pages/legal/sections/LegalUboDiscovery/LegalUboDiscovery';

import styles from './LegalPage.module.scss';

import { getAccessRoutes, getFaqItems, getWhereItLandsRows } from './LegalPage.data';

export const LegalPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <LegalHero />
      <LegalRegistryMarquee />
      <LegalLifeOfMatter />
      <NumberedRowsSection
        heading={t('Six places registry data does actual work in a firm.')}
        description={t(
          'Same underlying record, different question asked of it. Firms buy once and use it across practice groups rather than licensing a separate tool per team.',
        )}
        rows={getWhereItLandsRows(t)}
        actions={
          <Button type="blue" size="xl" href="/free-trial">
            {t('Run a group structure free')}
          </Button>
        }
      />
      <LegalUboDiscovery />
      <LegalSanctions />
      <LegalMonitoring />
      <LegalFounderStatement />
      <AccessRoutes
        background="navy"
        heading={t('How to access the data.')}
        lede={t('Seven routes into the same primary, government-sourced dataset. Pick the one that fits your stack.')}
        routes={getAccessRoutes(t)}
      />
      <LegalEvaluation />
      <Faq className={styles.faq} title={t('Straight answers.')} data={getFaqItems(t)} />
    </div>
  );
};
